import React from 'react';

const MediaSelectContext = React.createContext(null);

export const Provider = MediaSelectContext .Provider;
export const Consumer = MediaSelectContext .Consumer;

export default MediaSelectContext;
